import Twitter1 from "../../assets/images/twitter1.png";
import Twitter2 from "../../assets/images/twitter2.png";
// import Twitter3 from "../../assets/images/twitter3.png";
// import Twitter4 from "../../assets/images/twitter4.png";
// import Twitter5 from "../../assets/images/twitter5.png";
// import Twitter6 from "../../assets/images/twitter6.png";
export const twitterData = [
  {
    image: Twitter1,
    name: "Esther Howard",
    id: "@Estherhoward",
    desc: 'Big fan of <a href="#" style="color: #03A9F4;">@polarsyncshar</a> Always loved cryptocurrency because i believe in the future of decentralized money and Polar sync is helping to achieve this goal',
  },
  {
    image: Twitter2,
    name: "Eleanor Pena",
    id: "@Elanor",
    desc: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
  },
];
